import React from 'react';
import { occasions } from '../data/mockData';

const Occasions = ({ onOccasionSelect }) => {
  return (
    <section id="occasions" className="py-20 bg-neutral-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">Encuentra el vestido ideal para tu evento</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {occasions.map((occasion) => (
            <button
              key={occasion.id}
              type="button"
              data-testid={`occasion-card-${occasion.name}`}
              onClick={() => onOccasionSelect && onOccasionSelect(occasion.name)}
              className="group relative aspect-[3/4] overflow-hidden cursor-pointer bg-neutral-100 rounded-sm shadow-sm hover:shadow-xl transition-all duration-500 text-left"
            >
              <img
                src={occasion.image}
                alt={occasion.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent group-hover:from-black/80 transition-all duration-500"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                <h3 className="text-white text-xl font-light tracking-wide">{occasion.name}</h3>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Occasions;
